import RootNavigationMixin from 'GroomyRoot/mixins/Navigation.js'
import User from '@/mixins/User.js'

let Navigation = {
    mixins: [RootNavigationMixin, User]
}

export default Navigation
